import Axios from "../api/axios";
import config from "../../config";

const sendMailToEmployer = (
  to,
  name,
  letterText,
  fileName,
  templateId,
  dealID,
  client_name,
  client_email,
  encryptedDealID,
  employerEmailBody,
  employeeEmailBody,
  submitType,
  emailSubject
) => {
  return Axios.post(`${config.BASE_URL}send-email-to-employer`, {
    to: to, // Employer Email
    name: name, // Employer Name
    letterText: letterText,
    fileName: fileName,
    templateId: templateId,
    dealID: dealID,
    client_name: client_name, // Client Name
    client_email: client_email, // Client Email
    encryptedDealID: encryptedDealID,
    employerEmailBody: employerEmailBody, // Employer Email
    employeeEmailBody: employeeEmailBody, // Employee Email
    submitType: submitType,
    dynamic_subject: emailSubject
  });
};

export default sendMailToEmployer;
